import BackendService from './BackendService';

async function getExpenseTypes() {
  return BackendService.getData('/expense-types/');
}
async function createExpenseType(data = {}) {
  return BackendService.postData('/expense-types/', data);
}
async function updateExpenseType(id, data = {}) {
  return BackendService.patch(`/expense-types/${id}/`, data);
}
async function deleteExpenseType(id, data = {}) {
  return BackendService.destroy(`/expense-types/${id}/`, data);
}

const ExpenseTypeService = {
  getExpenseTypes,
  createExpenseType,
  updateExpenseType,
  deleteExpenseType,
};

export default ExpenseTypeService;
